import React, { useState } from 'react';

import { Assessment } from '@/services/assessmentsAPI';
import Chip from '@/components/Chip';

interface LockoutStatusBadgeProps {
  assessment: Assessment;
}

const LockoutStatusBadge: React.FC<LockoutStatusBadgeProps> = ({
  assessment,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  if (!assessment.is_worker_locked) return null;

  const formatDate = (dateString: string | null | undefined) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  const getLockReasonLabel = (reason: string | null | undefined) => {
    switch (reason) {
      case 'minimal_attempts':
        return 'Too many minimal attempts (< 2 questions)';
      case 'excessive_retries':
        return 'Excessive retries';
      default:
        return reason || 'Unknown';
    }
  };

  return (
    <div
      style={{ position: 'relative', display: 'inline-block' }}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <Chip color="error" label="STUCK" size="small" />
      {showTooltip && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            marginTop: '8px',
            backgroundColor: '#333',
            color: '#fff',
            padding: '12px 16px',
            borderRadius: '8px',
            fontSize: '13px',
            lineHeight: '1.5',
            whiteSpace: 'nowrap',
            zIndex: 1000,
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          }}
        >
          <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
            Worker Locked Out
          </div>
          <div>Reason: {getLockReasonLabel(assessment.lock_reason)}</div>
          <div>Locked: {formatDate(assessment.locked_at)}</div>
          <div>Dials: {assessment.dial_count ?? 0}</div>
          <div>Minimal attempts: {assessment.minimal_attempt_count ?? 0}</div>
          <div>Auto-reset: {formatDate(assessment.auto_reset_eligible_at)}</div>
          {assessment.last_admin_reset_at && (
            <div>
              Last admin reset: {formatDate(assessment.last_admin_reset_at)}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LockoutStatusBadge;
